import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-beige" data-id="element-61" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-content px-6 py-20 text-center" data-id="element-62" data-mp="1o33u6h0ytshr">
        <span className="mx-auto flex h-9 w-9 items-center justify-center rounded-full bg-white text-coral" data-id="element-63" data-mp="223ofpky9m2ey">
          <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-64" data-mp="1x5d69bbvttx9" />
        </span>

        <h2 className="mt-5 font-display text-[15px] font-bold uppercase tracking-[0.14em] text-ink" data-id="element-65" data-mp="19e7lqiuzydgm">
          Gwarancja satysfakcji
        </h2>

        <p className="mx-auto mt-4 max-w-md text-[12px] leading-relaxed text-muted" data-id="element-66" data-mp="14hh77zyubpxb">
          Jeśli w ciągu 14 dni uznasz, że materiały nie są dla Ciebie, napisz
          jedną wiadomość — zwrócę całą kwotę, bez pytań i bez formularzy. Chcę,
          żebyś podejmowała tę decyzję zupełnie spokojnie.
        </p>

        <a href="#faq" className="mt-5 inline-block text-[10px] font-semibold uppercase tracking-[0.14em] text-coral transition-colors duration-150 ease-out hover:text-coral-dark" data-id="element-67" data-mp="qlwslgq59tvp">
          Poznaj zasady zwrotu
        </a>
      </div>
    </section>;
}